import RoleManagementPage from '../containers/RoleManagement/Role'  
import Header from '../components/Header/Header' 
import SidebarPage from '../components/Sidebar/Sidebar'
import { MainContainer } from '../components/common/Containers' 
 
const RoleManagement = () => {
    return ( 
        <>  
            <SidebarPage />
            <MainContainer>    
                <Header /> 
                <main> 
                    <RoleManagementPage />  
                </main> 
            </MainContainer>
        </>
    )
}

export default RoleManagement
